import React from 'react';

import * as S from './ZeroTriggers.styles';

export const ZeroTriggerExecutions = () => {
  return (
    <S.Panel>
      <S.Circle>
        <S.JobAutomation />
      </S.Circle>
      <S.Heading>No automations history</S.Heading>
      <S.Message>
        Automation execution history will appear here when your automations are
        triggered.
      </S.Message>
    </S.Panel>
  );
};
